import { localisedDate, localisedTimeAgo } from '../../utils/format';
import { getCategoryPath, getArticlePath } from '../../utils/routes';
export function transformResult(sr, { languageId, now }) {
    return {
        ...sr,
        path: getArticlePath({ slug: sr.slug, languageId }),
        lastPublishedAgo: localisedTimeAgo(now, sr.lastPublishedAt, languageId),
        lastPublishedAtLocal: localisedDate(sr.lastPublishedAt, {
            languageId,
        }),
        category: {
            ...sr.category,
            path: getCategoryPath({ slug: sr.category.slug, languageId }),
            parentCategory: sr.category.parentCategory
                ? {
                    ...sr.category.parentCategory,
                    path: getCategoryPath({
                        slug: sr.category.parentCategory.slug,
                        languageId,
                    }),
                }
                : null,
        },
    };
}
//# sourceMappingURL=utils.js.map